import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
  },
});

const analyticsApi = {
  getOverviewStats: async () => {
    const response = await axios.get(`${API_URL}/api/admin/analytics/overview`, getHeaders());
    return response.data;
  },

  getRevenueAnalytics: async () => {
    const response = await axios.get(`${API_URL}/api/admin/analytics/revenue`, getHeaders());
    return response.data;
  },

  getSwapAnalytics: async () => {
    const response = await axios.get(`${API_URL}/api/admin/analytics/swaps`, getHeaders());
    return response.data;
  },

  getRetentionAnalytics: async () => {
    const response = await axios.get(`${API_URL}/api/admin/analytics/retention`, getHeaders());
    return response.data;
  },

  getUserRankings: async () => {
    const response = await axios.get(`${API_URL}/api/admin/analytics/rankings`, getHeaders());
    return response.data;
  },

  getDurationAnalytics: async () => {
    const response = await axios.get(`${API_URL}/api/admin/analytics/duration`, getHeaders());
    return response.data;
  },

  getFinancialMIS: async (startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    const queryStr = params.toString() ? `?${params.toString()}` : "";
    const response = await axios.get(`${API_URL}/api/admin/analytics/financial-mis${queryStr}`, getHeaders());
    return response.data;
  },

  downloadMISReport: async (startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    const queryStr = params.toString() ? `?${params.toString()}` : "";
    const response = await axios.get(`${API_URL}/api/admin/analytics/download-mis-report${queryStr}`, {
      ...getHeaders(),
      responseType: "blob",
    });
    return response.data;
  },

  downloadRawInvoices: async (startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    const queryStr = params.toString() ? `?${params.toString()}` : "";
    const response = await axios.get(`${API_URL}/api/admin/analytics/download-raw-invoices${queryStr}`, {
      ...getHeaders(),
      responseType: "blob",
    });
    return response.data;
  },
};

export default analyticsApi;
